import { all, fork } from "redux-saga/effects";
import countryWatcherSaga from "../country/saga";
import customerInfoWatcherSaga from "../customerInfo/saga";
import {
  quickOrderWatcherSaga,
  watchFetchQuickOrderData,
  watchUpdateQuickOrderSaga,
} from "../quickOrder/saga";
import orderHistoryWatcherSaga from "../orderhistory/saga";
import {
  orderHistoryImageWatcherSaga,
  imageDetailsWatcherSaga,
} from "../orderhistoryimage/saga";
import {
  draftOrderWatcherSaga,
  deleteOrderWatcherSaga,
} from "../draftOrder/saga";
import labelCatalogWatcherSaga from "../labelCatalog/saga";
import {
  notificationWatcherSaga,
  AddReadStatusWatcherSaga,
} from "../notifications/saga";
import userWatcherSaga from "../user/saga";
import shipmentWatcherSaga from "../shipmentTracking/saga";
import { invoiceWatcherSaga } from "../invoice/saga";
import { watchAnalyzeImage } from "../imageAnalyze/saga";
import configurationWatcherSaga from "../configuration/saga";
import { guestOrderWatcherSaga } from "../guestOrder/saga";
import { validateTokenWatcherSaga, photoUploadWatcherSaga } from "../photoUpload/saga";

export function* rootSaga(): any {
  yield all([fork(countryWatcherSaga)]);
  yield all([fork(customerInfoWatcherSaga)]);
  yield all([fork(quickOrderWatcherSaga)]);
  yield all([fork(watchFetchQuickOrderData)]);
  yield all([fork(watchUpdateQuickOrderSaga)]);
  yield all([fork(orderHistoryWatcherSaga)]);
  yield all([fork(orderHistoryImageWatcherSaga)]);
  yield all([fork(draftOrderWatcherSaga)]);
  yield all([fork(deleteOrderWatcherSaga)]);
  yield all([fork(labelCatalogWatcherSaga)]);
  yield all([fork(notificationWatcherSaga)]);
  yield all([fork(AddReadStatusWatcherSaga)]);
  yield all([fork(userWatcherSaga)]);
  yield all([fork(imageDetailsWatcherSaga)]);
  yield all([fork(shipmentWatcherSaga)]);
  yield all([fork(invoiceWatcherSaga)]);
  yield all([fork(watchAnalyzeImage)]);
  yield all([fork(configurationWatcherSaga)]);
  yield all([fork(guestOrderWatcherSaga)]);
  yield all([fork(validateTokenWatcherSaga)]);
  yield all([fork(photoUploadWatcherSaga)]);
}

export default rootSaga;
